
import { defineComponent, ref, computed, onMounted } from "vue";
import { store } from "@/store";
import { ActionTypes } from "@/store/actions";
import { CurrentLabel } from "@/types";

export default defineComponent({
  name: "LabelShapesButton",
  props: {
    isDisabled: Boolean,
  },
  setup(props) {
    const isDisabledRef = ref(false);

    onMounted(() => {
      if (props.isDisabled) {
        isDisabledRef.value = props.isDisabled;
      }
    });

    const currentLabel = computed<CurrentLabel>(() => store.getters.currentLabel);

    const showLabelShapes = () => {
      store.dispatch(ActionTypes.SET_MODAL, "labelShapes");
    };

    return {
      isDisabledRef,
      currentLabel,
      showLabelShapes,
    };
  },
});
